import { BaseError } from '@sdk/errors/BaseError';
import { IncompatibleNetworkError } from '@sdk/errors/NetworkError';

export class AuthorisationError extends BaseError {
  constructor(
    message = 'Unauthorised to proceed',
    { cause, data }: { cause?: unknown; data?: Record<string, unknown> } = {},
  ) {
    super(message, { cause, data });
  }
}

export class KYCError extends AuthorisationError {
  constructor(
    message = 'KYC verification required',
    { cause, data }: { cause?: unknown; data?: Record<string, unknown> } = {},
  ) {
    super(message, { cause, data });
  }
}

export * from './NetworkError';
export * from './BaseError';

export type IxError = BaseError | AuthorisationError | KYCError | IncompatibleNetworkError;
